import { useIntl } from '@/intl'
import { useSelectFilter } from '@/scopes/search/search/domain/hooks'
import { getFilterAISelection } from '@/scopes/search/search/infrastructure/store/selectors'
import { useSearchStoreSelector } from '@/scopes/search/search/infrastructure/store/useSearchStore'
import { TokenWrapper } from '@/scopes/search/search/pages/SearchPage/components/SelectedFiltersTokens/index'
import { Typography } from '@sunwebgroup/ui-components/uds'
import { useCallback } from 'react'

export function HasAvailabilityTokens() {
  const intl = useIntl()
  const { isFetching, isLoading, selectedOption, selectedValue, setSelection } = useSelectFilter('HasAvailability')
  const aiSelectedValue = useSearchStoreSelector(getFilterAISelection, 'HasAvailability') as string

  const handleRemoveClick = useCallback(() => {
    setSelection(undefined)
  }, [setSelection])

  if (isLoading)
    return null
  if (!selectedOption)
    return null

  return (
    <TokenWrapper value={selectedValue} disabled={isFetching} dismissible onDismissClick={handleRemoveClick} icon={aiSelectedValue === selectedValue ? 'Ai' : undefined}>
      <Typography variant="body-m-bold-tight">
        {intl.formatMessage({
          id: 'filter_chips_has_availability_prefix',
        })}
        :
      </Typography>
      {' '}
      {selectedOption.name}
    </TokenWrapper>
  )
}
